import { create } from 'zustand';

import { toUser } from '@/data/dto/user.dto';
import { USER_STORAGE, User, UserHttp } from '@/data/models/user.interface';
import { storageService } from '@/data/services/storage.service';

export interface UserState {
  user: User;
  setUser: (_user: User) => void;
  updateUser: (_updates: Partial<User>) => void;
  clearUser: () => void;
  hasPermission: (_permission: string) => boolean;
  isAuthenticated: () => boolean;
  setIsLoggingIn: (_isLoggingIn: boolean) => void;
}

const initialUser = toUser(storageService.get<UserHttp>(USER_STORAGE) || {});

export const useUserStore = create<UserState>((set, get) => ({
  user: initialUser,

  setUser: (user: User) => {
    storageService.set(USER_STORAGE, user);
    set({ user });
  },

  updateUser: (updates: Partial<User>) =>
    set((state) => ({
      user: { ...state.user, ...updates },
    })),

  clearUser: () => {
    storageService.remove(USER_STORAGE);
    set({ user: toUser({}) });
  },

  hasPermission: (permission: string) => {
    const state = get();
    return state.user.permissions?.includes(permission) || false;
  },

  isAuthenticated: () => {
    const state = get();
    return state.user.isAuthenticated || false;
  },

  setIsLoggingIn: (isLoggingIn: boolean) => {
    const state = get();
    set({ user: { ...state.user, isLoggingIn } });
  },
}));

export default useUserStore;
